export default __webpack_public_path__ + "static/media/android-3.75d0e1f8.jpeg";